<template>
  <div class="contentBox">
    <el-row :gutter="0" type="flex" justify="center">
      <el-col :xs="22" :sm="22" :md="22">
        <div class="Box-form">
          <el-form
            size="small"
            :inline="true"
            :model="listQuery"
            class="demo-form-inline"
          >
            <el-form-item>
              <el-input
                placeholder="请输入关键词搜索"
                v-model="listQuery.keywords"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                round
                class="search"
                @click="(listQuery.page = 1), load()"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="content">
          <div class="card">
            <lostCard v-bind="{ cardData }" />
            <div class="page">
              <el-pagination
                @current-change="load"
                :current-page.sync="listQuery.page"
                :page-size.sync="listQuery.size"
                :pager-count="3"
                layout="total, prev, pager, next, jumper"
                :total="totalNum"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import lostCard from "../components/lostCard.vue";
import { foundIndex, read, save } from "@/api/pilotService/lostFound";
import { formatTimeNum } from "@/utils";
export default {
  components: { lostCard },
  data() {
    return {
      listQuery: {
        page: 1,
        size: 8,
        keywords: "",
      },
      cardData: [],
      totalNum: 0,
    };
  },
  methods: {
    load() {
      foundIndex(this.listQuery)
        .then((res) => {
          res.data.data.forEach((Element) => {
            Element.create_time = formatTimeNum(Element.create_time, "Y-M-D");
          });
          this.cardData = res.data.data;
          this.totalNum = res.data.count;
        })
        .catch((err) => {
          ;
        });
    },
  },
};
</script>

<style scoped>
.contentBox {
  /* background-color: hsl(0, 1%, 97%); */
  /* width: 65%; */
  /* padding: 30px 100px; */
  /* padding: 1% 0; */
  /* margin: 0 auto; */
}
.Box-form {
  text-align: right;
  margin-bottom: 30px;
}
.el-input {
  width: 280px;
}
.el-input /deep/.el-input__inner {
  border-radius: 50px;
}
.search {
  margin-right: -10px;
  background-color: rgba(50, 88, 159, 1);
  color: #ffffff;
}
/* .card {
  margin-bottom: 60px;
} */
.page {
  float: right;
  margin-bottom: 40px;
}
@media only screen and (max-width: 768px) {
  .Box-form {
    /* text-align: center; */
    margin-bottom: 10px;
  }
    .el-input {
    width: 50vw;
  }
}
</style>